import { createApiClient } from './ApiClientFactory'

const BASE_URL = import.meta.env.VITE_BASE_URL || 'http://localhost:5000/api/v1'
const apiClient = createApiClient(`${BASE_URL}/tasks`)

export default {
  async getTasks(params = {}) {
    const response = await apiClient.get('/', { params })
    return response.data
  },

  async getTask(taskId) {
    const response = await apiClient.get(`/${taskId}`)
    return response.data
  },

  async createTask(payload) {
    const response = await apiClient.post('/', payload)
    return response.data
  },

  async updateTask(taskId, payload) {
    const response = await apiClient.patch(`/${taskId}`, payload)
    return response.data
  },

  async scheduleTask(taskId, payload) {
    const response = await apiClient.patch(`/${taskId}/schedule`, payload)
    return response.data
  },

  async completeTask(taskId, payload = {}) {
    const response = await apiClient.patch(`/${taskId}/complete`, payload)
    return response.data
  },

  async returnTask(taskId) {
    const response = await apiClient.patch(`/${taskId}/return`)
    return response.data
  },

  async deleteTask(taskId) {
    const response = await apiClient.delete(`/${taskId}`)
    return response.data
  },

  async getGoldenDays(params = {}) {
    const response = await apiClient.get('/golden-days', { params })
    return response.data
  },

  async markGoldenDay(payload) {
    const response = await apiClient.post('/golden-days', payload)
    return response.data
  },
}
